import React from 'react'
import './WriterAccessModal.css'

const ModalBody = ({title, description}) => {
    return (
        <div className="writerAccessModal__body_first">
            <p className="writerAccessModal_title">{title}</p>
            <p className="writerAccesssModal_description">{description}</p>
            
        </div>
    )
}

export default ModalBody